import md5 from "js-md5";
import { noSignAction, signAction, signActionTime, signUserAction, unsignUserAction, signActionTimeByGuest } from "../utils/http";
import tools from "../utils/fun";
import httpConfig from "../baseConfig/httpConfig";
import dataConfig from "../baseConfig/dataConfig";
import eventConfig from "../baseConfig/eventConfig";
import JsEncrypt from 'jsencrypt';
import msg from "../proto/Msg";

let ServerManager = {};


/**
 * 注册
 */
ServerManager.register = function (self, userName, password, country, codeReference, callback, errCallback = null) {
    let device = tools.getDevice(self);
    let platform = tools.getPlatForm();
    let cn = window.localStorage.getItem('url-channel');
    if (!cn) cn = self.$store.getters['common/getChannel'];

    let param = {
        emailAccount: userName,
        password: md5(password + httpConfig.nsk).toString(),
        device: device,
        channel: cn,
        country: 'in',
        nickname: userName,
        platform: platform,
        codeReference: codeReference
    };
    if (window.isNewPlayer) param['clientTag'] = 1;
    if (window.gaid) param['gaid'] = window.gaid;
    let url = httpConfig.baseUrl() + "/api/center/mini/email/register";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result == 1) {
                self.$store.commit("user/setToken", res.data);
                callback(res.data);
            } else {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
                errCallback(res.info);
            }
        })
        .catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

        });
}


/**
 * 登录
 */
ServerManager.login = function (self, userName, password, country, callback, errCallback = null) {
    let device = tools.getDevice(self);
    let platform = tools.getPlatForm();
    let param = {
        emailAccount: userName,
        password: md5(password + httpConfig.nsk).toString(),
        device: device,
        channel: "system",
        country: 'in',
        nickname: userName,
        platform: platform
    };
    let url = httpConfig.baseUrl() + "/api/center/email/login";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result != 1) {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
                errCallback(res.info);
            } else {
                self.$store.commit("user/setToken", res.data);
                callback(res.data);
            }
        })
        .catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

        });
}

/**
 *找回密码 
 */
ServerManager.findPassword = function (self, userName, password, country, codeReference, callback, errCallback = null) {
    let param = {
        account: tools.getFullPhone(userName, country.code),
        password: md5(password + httpConfig.nsk).toString(),
        codeReference: codeReference,
    };
    let url = httpConfig.baseUrl() + "/api/center/findPassword";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result == 1) {
                let data = res;
                callback(data);
            } else {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
                errCallback(res.info);
            }
        })
        .catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
}
/**
 * 游客登陆
 */
ServerManager.getGuestAccountJson = function (self, callback, errCallback = null) {
    let country = self.$store.getters["common/getCountry"];
    let userProto = getGuestAccountHeader(self, country);
    let url = httpConfig.baseUrl() + "/api/center/guestJson";
    noSignAction("POST", url, userProto, 0)
        .then((res) => {
            if (typeof res == "string") {
                res = JSON.parse(res);
            }
            let guest = {
                token: res.data.token,
                secretKey: res.data.secretKey,
                country: country
            };
            self.$store.commit("user/setGuestAccount", guest);
            callback(res.data);
        })
        .catch(error => {
            if (errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
}

ServerManager.getGuestAccount = function (self, callback, errCallback = null) {
    let country = self.$store.getters["common/getCountry"];
    let userProto = msg.User.create(getGuestAccountHeader(self, country));
    let up = msg.User.encode(userProto).finish();
    let url = httpConfig.baseUrl() + "/api/center/guest";
    unsignUserAction(self, "POST", url, up, 0, (res) => {
        if (typeof res == "string") {
            res = JSON.parse(res);
        }
        let guest = {
            token: res.data.token,
            secretKey: res.data.secretKey,
            country: country
        };
        self.$store.commit("user/setGuestAccount", guest);
        callback(res.data);
    }, (err) => {
        if (errCallback) errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
    })
}

const getGuestAccountHeader = function (self, country) {
    let device = tools.getDevice(self);
    device['udid'] = tools.getUniqueId(country);
    let time = new Date().getTime().toString();
    let sign = "";
    let userProto = {
        token: "",
        time: time,
        sign: sign,
        device: device,
        country: country,
    };
    return userProto;
}

const getUserProtoNopb = function (self) {
    let login = tools.getLoginToken(self);
    if (!login.isLogin && !login.isDemo) {
        tools.toPage(self, { path: '/', query: { action: "login" } }, true);
        return;
    }

    let device = tools.getDevice(self);
    let token = login.token;
    if (!token && login.isDemo) {
        token = login.demoToken;
    }
    if (!device['udid']) {
        device['udid'] = tools.getUniqueId(login.country);
    }
    let time = new Date().getTime().toString();
    let sign = "";
    let ret = {
        token: token,
        time: time,
        sign: sign,
        device: device,
        country: login.country,
    };
    return ret;
}

const getUserProto = function (self, isForce = false) {
    let login = tools.getLoginToken(self);
    if (!login.isLogin && !login.isDemo) {
        tools.toPage(self, { path: '/', query: { action: "login" } }, true);
        return;
    }
    let device = tools.getDevice(self);
    let token = login.token;
    if (!token && login.isDemo) {
        token = login.demoToken;
    }
    if (!device['udid']) {
        device['udid'] = tools.getUniqueId(login.country);
    }
    let time = new Date().getTime().toString();
    let sign = "";
    let userProto = msg.User.create({
        token: token,
        time: time,
        sign: sign,
        device: device,
        country: login.country,
    });
    return msg.User.encode(userProto).finish();
}

ServerManager.sendEmailCode = function (self, userName, country, callback, errCallback, verityCodeType) {

    if (!verityCodeType) verityCodeType = 9;
    let param = {
        emailAccount: userName,
        verityCodeType: verityCodeType,
        country: 'in'
    };
    let url = httpConfig.baseUrl() + "/api/payments/sms/email/code";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
                errCallback(res.info);
            }
        })
        .catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

        });
}
ServerManager.checkEmailCode = function (self, userName, country, code, callback, errCallback, verityCodeType) {
    let param = {
        account: userName,
        code: code,
        verityCodeType: verityCodeType
    };
    let url = httpConfig.baseUrl() + "/api/center/checkCode";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
                errCallback(res.info);
            }
        })
        .catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

        });
}
ServerManager.findPassword = function (self, userName, password, country, codeReference, callback, errCallback = null) {
    let param = {
        emailAccount: userName,
        password: md5(password + httpConfig.nsk).toString(),
        codeReference: codeReference,
    };
    let url = httpConfig.baseUrl() + "/api/center/email/findPassword";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result == 1) {
                let data = res;
                callback(data);
            } else {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
                errCallback(res.info);
            }
        })
        .catch(error => {
            errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

        });
}
ServerManager.CheckAccount = function (self, userName, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/center/checkEmail";
    let param = {
        emailAccount: userName,
    };
    noSignAction("POST", url, param, 0)
        .then((res) => {
            callback(res);
            if (res.result != 1) {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
            }
        })
        .catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
}

ServerManager.getUserInfo = function (self, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/center/user/getUserInfo";
    let platform = tools.getPlatForm();
    let param = {
        platform: platform
    };

    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result != 1) {
                //跳转登录界面
                tools.toPage(self, { path: '/', query: { action: "login" } }, true);
            } else {
                self.$store.commit("temp/setUserRefreshStamp", 0);
                self.$store.commit("user/setUserData", res.data);
                self.$store.commit("common/setLanguage", res.data.language);
                self.$store.commit("common/setBgm", res.data.bgm);
                self.$store.commit("common/setSfx", res.data.sfx);
                self.$store.commit("common/setNotice", res.data.notice);
                self.$store.commit("common/setChannel", res.data.channel);
                self.$store.commit("common/setUserName", res.data.email);
    
                //充值上报af
                let money = self.$store.getters["user/getMoney"];
                if (money != eventConfig.NO_LOGIN_FLAG &&  res.data.chip > money) {
                    tools.setAfDepositeEvent(self);                    
                };
                callback(res.data);
            }
        }).catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

ServerManager.checkNicknameExist = function (self, nickname, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/center/user/checkNicknameExist";

    let param = {
        nickname: nickname
    };

    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            console.log("checkNicknameExist", res);
            if (res.result != 1) {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
            }

            callback(res);
        })
            .catch(error => {
                if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

            });
    }
}

ServerManager.updateUserInfo = function (self, columnName, value, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/center/user/updateUserInfo";

    let param = {
        columnName: columnName,
        value: value
    };

    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            console.log("updateUserInfo", res);

            if (res.result != 1) {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
            }
            callback(res);
        })
            .catch(error => {
                if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));

            });
    }
}
//api/partner/lm/resetLmName
ServerManager.resetLmName = function (self, nickname, value, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/partner/lm/resetLmName";

    let param = {
        nickname: nickname,

    };

    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result != 1) {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
            }
            callback(res);
        }).catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}
ServerManager.updateUser = function (self, columnName, value, callback, errCallback) {
    let url = httpConfig.baseUrl() + "/api/center/user/updateUser";

    let param = {
        columnName: columnName,
        value: value
    };

    let httpHandler = signActionTime(self, "POST", url, param, { urlStr: "" }, 0);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result != 1) {
                self.$toast.show(
                    self.$t("err." + res.result)
                );
            }
            callback(res);
        }).catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

const setRSA = function (gameId, self) {
    var crypt = new JSEncrypt();
    crypt.setPublicKey("MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJ6NpwDHN2xwNDJuY/c5AzpP2hRhbsha40uxklHudkR3vkDgEPG0TZwwQUptL+xq3E8k+8W64/XMfXcG7+qC+y8CAwEAAQ==");
    let time = new Date();
    let second = Math.floor(time.getTime() / 1000);
    console.log(second);
    let microGameId = gameId;

    let login = tools.getLoginToken(self);
    let accessToken = login.token;
    //如果游戏是试玩模式并且未登录才使用guest
    if (!accessToken && login.isDemo) {
        accessToken = login.demoToken;
    }
    var text = `${accessToken}-${microGameId}-${second}`;
    // console.log(text);
    // Encrypt the data with the public key.
    var enc = crypt.encrypt(text);
    enc = enc.replace(/\+/g, "-").replace(/=/g, "_");
    return enc;
}

/**
 * 未登录时首页根据ip判断 
 * @param {*} callback 
 */
ServerManager.checkBanStatusByIp = function (callback) {
    let url = "/api/center/limitCountry";
    noSignAction("GET", url, 1000)
        .then((res) => {
            let data = res.data;
            let status = data.limit && (parseInt(data.limit) == 1);
            !status && (status = data.country != 'IN');
            //测试环境
            tools.isDev() && (status = false);
            callback(status);
        })
        .catch(error => {
            callback(false);
        });
}

/**
 * 获取游戏地址 
 * @param {*} self 
 * @param {*} gameId 
 * @param {*} roomId 
 * @param {*} callback 
 * @param {*} errcallback 
 */
ServerManager.getGameUrl = function (self, gameId, roomId, isDemo, callback, errcallback) {
    let url = httpConfig.baseUrl() + "/api/partner/lm/getLoginUrl";
    let param = {
        gameId: gameId,
        roomId: roomId,
        demo: (isDemo ? 1 : 0)
    };
    let httpHandler = signActionTimeByGuest(self, "POST", url, param, { urlStr: "" }, 30000, false);
    if (httpHandler) {
        httpHandler.then((res) => {
            if (res.result == 1) {
                callback(res.data);
            } else {
                //弹出继续游戏弹出功能
                if (res.result == eventConfig.CONTINUE_GAME_ID) {
                    tools.emit(eventConfig.CONTINUE_GAME, res.data);
                } else {
                    errcallback(res.result);
                }
            }
        }).catch(error => {
            if(errcallback) errcallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
    }
}

/**
 * facebook 登录
 * @param {*} self 
 * @param {*} facebookUid 
 * @param {*} idToken 
 * @param {*} callback 
 * @param {*} errCallback 
 */
ServerManager.facebookLogin = function (self, facebookUid, idToken, callback, errCallback) {
    let device = tools.getDevice(self);
    let cn = self.$store.getters["common/getChannel"];
    let param = {
        "facebookUid": facebookUid,
        "uid": "",
        "idToken": idToken,
        "appid": "195254138231933",
        "device": device,
        "platform": tools.getPlatForm(),
        "country": self.$store.state.common.country,
        "channel": cn
    };
    let url = httpConfig.baseUrl() + "/api/center/mini/register/facebook";
    noSignAction("POST", url, param, 0)
        .then((res) => {
            if (res.result != 1) {
                errCallback(self.$t("err." + res.result));
            } else {
                self.$store.commit("user/setToken", res.data);
                callback(res);
            }
        })
        .catch(error => {
            if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
        });
}

/**
 * 刷新用户信息
 * @param {*} self 
 */
ServerManager.refreshUser = function (self, isforce, callback, errCallback) {
    let isError = true;
    if (self.$store.state.user.isLogin) {
        if (isforce || self.$store.getters["temp/isRefreshUser"]) {
            isError = false;
            this.getUserInfo(self, data => {
                if (callback) callback();
            }, error => {
                if (errCallback) errCallback();
            });
        }
    }
    if (errCallback && isError) errCallback();
}

/**
 * 查找正在进行中的游戏
 * @param {*} self 
 * @param {*} callback 
 */
ServerManager.isContinueGame = function (self, callback) {
    let url = httpConfig.baseUrl() + "/api/partner/lm/checkIsOnline";
    let httpHandler = signActionTime(self, "POST", url, "", { urlStr: "" }, 30000, false);
    if (httpHandler) {
        httpHandler.then((res) => {
            let rlt = {
                config: null,
                money: null
            }
            if (res.result == 1) {
                rlt.money = res.data.money;
                if (res.data.config) {
                    rlt.config = {
                        gameId: res.data.config.gameId,
                        roomId: res.data.config.id,
                        isDemo: (res.data.config.join == 0 ? true : false)
                    }
                }
            } else if (res.result == eventConfig.CONTINUE_GAME_ID) {
                rlt.config = {
                    gameId: res.data.gameId,
                    roomId: res.data.id,
                    isDemo: (res.data.join == 0 ? true : false)
                }
            }
            callback(rlt);
        }).catch(error => {

        });
    }
}


/**
 * 上报firebase 的 accesstoken
 * @param {*} self 
 * @param {*} token 
 * @param {*} userId 
 * @param {*} callback 
 * @param {*} errCallback 
 */

ServerManager.uploadFirebaseToken = async function (self, token, userId, uuid, callback, errCallback) {
    //每天正确上报一次
    if (!uuid) uuid = tools.guid2();
    let data = {
        token: token,
        uuid: uuid,
        uid: userId
    }
    let isUpload = await this.$store.dispatch("common/checkUploadFirebaseToken", data);
    if (isUpload) {
        let url = httpConfig.baseUrl() + "/api/sys/uploadFirebaseMsgToken";
        let params = {
            userId: userId,
            platform: tools.getPlatForm(),
            firebaseMsgToken: token,
            deviceUid: uuid,
            country: self.$store.state.common.country,
            channel: self.$store.getters["common/getChannel"]
        };
        if (window.gaid) params['gaid'] = window.gaid;
        if (!params.firebaseMsgToken) params.firebaseMsgToken = "";
        noSignAction("POST", url, params, 0)
            .then((res) => {
                if (res.result != 1) {
                    errCallback(res.info);
                } else {
                    callback(res.data);
                }
            })
            .catch(error => {
                if(errCallback) errCallback(tools.getErrorInfo(self, 'TIPS_NET_ERROR'));
            });
    } else {
        callback(null);
    }
}

/**
 * 日常操作用户上报
 *  0访问上报1，登陆上报2，注册上报 3.更新下载上报
 *  101 //大厅ABTest 上报 老版本
 *  102 //大厅ABTest 上报 新版本
 * @param {*} self 
 * @param {*} type 
 * @param {*} uuid 
 */
ServerManager.uploadWebLog = function (self, type, uuid) {
    //用户的uuid
    if (uuid && uuid != "") window.androidUuid = uuid;
    if (!uuid || uuid == "") uuid = tools.guid2();
    //用户登录信息
    let userId = !self.$store.state.user.isLogin ? 0 : self.$store.state.user.realUser.id;
    let ext = window.AndroidBridge ? "lite" : "h5";
    let winKey, localKey;
    if (type == 0) {
        winKey = 'dailyLog' + userId;
        localKey = "casino-daily-" + userId;
        if (!window[winKey]) {
            window[winKey] = window.localStorage.getItem(localKey);
        }
        let date = (new Date()).getDate().toString();
        if (window[winKey]) {
            //同一天只上报一次
            if (date == window[winKey]) {
                return;
            }
        }
        window[winKey] = date;
        window.localStorage.setItem(localKey, date);
    } else if (type == 101) {
        winKey = "HallABTest" + userId;
        localKey = "casino-abtest-" + userId;
        if (!window[winKey]) {
            window[winKey] = window.localStorage.getItem(localKey);
        }
        //存在则不上报
        if (window[winKey]) {
            return;
        }
        let date = (new Date()).getDate().toString();
        window[winKey] = date;
        window.localStorage.setItem(localKey, date);
        ext = "homeTest";
        let isOldUser = window.localStorage.getItem("isOldUser");
        //新的方式
        if (isOldUser && parseInt(isOldUser) == 1) {
            type = 102;
            ext = "_new";
        }
    }

    //每日非登陆状态上报
    let thander = setTimeout(() => {
        if (thander) clearTimeout(thander);
        let url = httpConfig.baseUrl() + "/api/log/common/webviewLog";
        let userAgent = (window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : "";
        let params = {
            deviceUid: uuid,
            type: type, //上报类型 0访问上报1，登陆上报2，注册上报 3.更新下载上报
            userId: userId,
            userAgent: userAgent, //浏览器版本
            country: self.$store.state.common.country,
            platform: tools.getPlatForm(),
            clientTag: (window.isNewPlayer ? 1 : 0), //是否新用户
            ext: ext,
        };

        noSignAction("POST", url, params, 0)
            .then((res) => {
                console.log(res);
            })
            .catch(error => {
                console.log(error);
            });
    }, 300);
}

export default ServerManager;


// WEBPACK FOOTER //
// ./src/interface/server.js